import {LabelWithoutJson, LinkText} from '@/components/atoms'
import {ReadOnly, LinkTextWithIcon, AddressField, TabsComponent, SectionTitle} from '@/components/molecules'
import {FONT_SIZE, FONT_WEIGHT} from '@/utils/constants/globalStyle'
import './_storeDetailsBlock.scss'
const Section = ({id, title}) => {
  return <SectionTitle id={id} label={title} />
}

const ReadOnlyField = ({id, label, value, isValueDiasbledInput = false}) => (
  <ReadOnly id={id} label={label} value={value} isValueDiasbledInput={isValueDiasbledInput} />
)

const CustomerInformation = () => (
  <>
    <Section id={'Customer Information'} title="Customer Information" />
    <div className="flex items-center gap-2">
      <div className="w-49">
        <div className={`sdb-borderbottom  flex h-[38px] items-center pb-2 pt-2`}>
          <div className="flex w-1/2 items-center">
            <LabelWithoutJson id={'Customer ID'} isIconVisible={true} text="Customer ID" />
          </div>
          <LinkTextWithIcon id={'cust_id_number'} isIconVisible={true} text="5636491" />
        </div>
        <ReadOnlyField id={'pace_id'} label="PACE ID" value="" />
      </div>
      <div className="w-49">
        <ReadOnlyField id={'customer_name'} label="Customer Name" value="Steven Spielberg" />
        <ReadOnlyField id={'login_name'} label="Login Name" value="5385459106" />
      </div>
    </div>
  </>
)

const StoreInformation = () => (
  <>
    <Section id={'Store Information'} title="Store Information" className="pb-4 pt-6" />
    <div className="flex items-center gap-2">
      <div className="w-49">
        <ReadOnlyField id={'cus_type'} label="Customer Type" value="CEDO" />
        <ReadOnlyField id={'cust_ref_num'} label="Customer Ref Number" value="5636491" />
        <ReadOnlyField id={'last_view'} label="Last View" value="2024-11-23 11:23:00" />
        <ReadOnlyField id={'current_points'} label="Current Points" value="1205" />
      </div>
      <div className="w-49">
        <ReadOnlyField id={'store_name'} label="Store Name" value="Alkin Kebap" />
        <ReadOnlyField id={'store_nickname'} label="Store Nickname" value="San" isValueDiasbledInput={true} />
        <ReadOnlyField id={'platform_type'} label="Platform Type" value="Web" />
        <ReadOnlyField id={'rewards_points'} label="Deleted Reward Points" value="10" />
      </div>
    </div>
  </>
)

const Address = () => (
  <>
    <Section id={'Address'} title="Address" />
    <AddressField id={'detail_address'} text="123, Path, Yavuztürk MH. Tarih Caddesi No: 121, Üsküdar, Turkey" />
    <div className="flex items-baseline gap-2">
      <div className="w-49">
        <ReadOnlyField id={'parent_id'} label="Parent Member ID" value="23232343" />
        <ReadOnlyField id={'edo_flag'} label="EDO Flag" value="5636491" />
        <LinkText
          fontSize={FONT_SIZE.XS}
          fontWeight={FONT_WEIGHT.BOLD}
          className="pt-4"
          text="View Additional Inform..."
        />
      </div>
      <div className="w-49">
        <ReadOnlyField id={'locate_id'} label="Locate" value="" />
      </div>
    </div>
  </>
)

const RegistrationDetails = () => (
  <>
    <Section id={'Registration Details'} title="Registration Details" />
    <div className="flex items-end gap-2">
      <div className="w-49">
        <ReadOnlyField id={'bill_type'} label="Billing Type" value="Sold to / Bill to / Ship To" />
        <ReadOnlyField id={'store_date'} label="Store Registration Date" value="2024-11-23 11:23:00" />
      </div>
      <div className="w-49">
        <ReadOnlyField id={'vat_date'} label="VAT Registration Date" value="2024-11-23 11:23:00" />
      </div>
    </div>
  </>
)

const DeliveryData = () => {
  const tabList = [
    {id: 'Route Type 1', tabLabel: 'Route Type 1', tabComponent: ''},
    {id: 'Route Type 2', tabLabel: 'Route Type 2', tabComponent: ''},
    {id: 'Route Type 3', tabLabel: 'Route Type 3', tabComponent: ''},
  ]

  return (
    <>
      <Section id={'Delivery Data'} title="Delivery Data" className="pb-4 pt-6" />
      <TabsComponent isBorderVisible={true} tabList={tabList} defaultTabIndex={0} />
      <div className="flex items-baseline gap-2 pt-2">
        <div className="w-49">
          <ReadOnlyField id={'location_id'} label="Localization ID" value="80DG" />
          <ReadOnlyField id={'route_type'} label="Route Type" value="1" />
          <ReadOnlyField id={'delivery_service'} label="Delivery Service" value="24" />
          <ReadOnlyField id={'delivery_days'} label="Delivery Days" value="All Week" />
        </div>
        <div className="w-49">
          <ReadOnlyField id={'route_id'} label="Route ID" value="MX1B45" />
          <ReadOnlyField id={'moa'} label="MOA" value="100" />
          <ReadOnlyField id={'cuttoff_time'} label="Cutoff Time" value="21:00" />
        </div>
      </div>
    </>
  )
}

export const StoreDetailsBlock = () => {
  return (
    <>
      <CustomerInformation />
      <StoreInformation />
      <Address />
      <RegistrationDetails />
      <DeliveryData />
    </>
  )
}

export default StoreDetailsBlock
